import React, { FC, useEffect } from 'react';
import { SelectInput, NumberInput, useTranslate } from 'react-admin';
import { isEqual, get } from 'lodash';
import { required, minValue } from 'react-admin';
import { maxValue } from 'react-admin';
import { useFormState } from 'react-final-form';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { useForm } from 'react-final-form';

interface CodeFormProps {
  scopedFormData?: Record<string, any>;
  getSource: (source: string) => string;
}

export const CodeForm: FC<CodeFormProps> = ({ scopedFormData, getSource }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  const form = useForm();

  const { values } = useFormState();
  const isShortCode = isEqual(get(values, getSource('paymentToken.algorithm')), 'SHORTCODE');

  useEffect(() => {
    if (!isShortCode) {
      form.change(getSource('paymentToken.length'), undefined);
    }
  }, [isShortCode, form, getSource]);
  return (
    <>
      <SelectInput
        label={t('codeGenerationAlgorithm')}
        source={getSource('paymentToken.algorithm')}
        defaultValue='UUID'
        choices={[
          { id: 'UUID', name: t('UUID') },
          { id: 'SHORTCODE', name: t('shortCode') },
        ]}
        validate={required()}
        className={classes.inputWidth}
        record={scopedFormData}
      />
      {isShortCode && (
        <NumberInput
          label={t('codeLength')}
          source={getSource('paymentToken.length')}
          min={MIN_SHORT_CODE_LENGTH}
          max={MAX_SHORT_CODE_LENGTH}
          step={1}
          validate={[minValue(MIN_SHORT_CODE_LENGTH), maxValue(MAX_SHORT_CODE_LENGTH), required()]}
          className={classes.inputWidth}
          record={scopedFormData}
        />
      )}
      {!getSource('').includes('veengu_business_purchase_byStaticQr') && (
        <NumberInput
          label={t('codeLifetime')}
          source={getSource('paymentToken.lifetime')}
          defaultValue={20}
          min={MIN_SHORT_CODE_LIFETIME}
          max={MAX_SHORT_CODE_LIFETIME}
          step={1}
          validate={[
            minValue(MIN_SHORT_CODE_LIFETIME),
            maxValue(MAX_SHORT_CODE_LIFETIME),
            required(),
          ]}
          className={classes.inputWidth}
          record={scopedFormData}
        />
      )}
    </>
  );
};

const MIN_SHORT_CODE_LENGTH = 8;
const MAX_SHORT_CODE_LENGTH = 16;
const MIN_SHORT_CODE_LIFETIME = 1;
const MAX_SHORT_CODE_LIFETIME = 1440;
